// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2f-l9","rootSuccess":"CompleteLink_rootSuccess__1fwgn","rootFailure":"CompleteLink_rootFailure__2kW9X","isDisabled":"CompleteLink_isDisabled__1vSAJ"};